module.exports = __webpack_public_path__ + "static/media/telegram2.0d5ee41e.png";